import { CloseCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Avatar, FloatButton, Space, Tag } from "antd";
import { List, Toast } from "antd-mobile";
import axios from "axios";
import $ from "jquery";
import React, { useContext, useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import ReactFileReader from "react-file-reader";
import { useNavigate } from "react-router-dom";
import PsContext from "../../context";
import { getFileLiveUrl, jsonToQuery, momentDate } from "../../utils";
import { SELECT_USER_PHOTO } from "../../utils/data";
import { ServiceUrl } from "../../utils/serviceUrl";
import Header from "../header";

const Internship = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
  const [showAdd1, setShowAdd1] = useState(false);
  const [showView, setShowView] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [dataView, setDataView] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [totalBalance, setTotalBalance] = useState(0);
  const [showFeeModal, setShowFeeModal] = useState(false);
  const [viewData, setViewData] = useState([]);
  const [selectedFile, setSelectedFile] = useState("");
  const [oldFile, setOldFile] = useState("");
  const [showList, setShowList] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [showListView, setShowListView] = useState(false);

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 50,
    },
    total: 0,
  });

  useEffect(() => {
    if (!loader) getReport();
  }, [JSON.stringify(tableParams.pagination)]);

  const getRandomuserParams = (params) => ({
    limit: params.pagination?.pageSize,
    page: params.pagination?.current,
    name: params.pagination?.name,
    from_date: params.pagination?.from_date,
    to_date: params.pagination?.to_date,
    // academic_department: params.pagination?.academic_department,
    //...params,
  });

  const fileReaderChange = (file) => {
    var types = [
      "image/png",
      "image/jpeg",
      "image/JPEG",
      "image/jpg",
      "image/PNG",
      "image/JPG",
    ];
    if (!types.includes(file.fileList[0].type)) {
      alert("Please select an Image with file extension .jpg or .png", "error");
      return;
    }

    if (file.fileList[0].size < 10000) {
      alert("File size must greater than 10 kb", "error");
      return;
    }

    if (file.fileList[0].size > 300000) {
      alert("File size must less than 300 kb", "error");
      return;
    }

    setSelectedFile(file.base64);
  };

  const clearFile = () => {
    if (!window.confirm("Do you want to remove ?")) return;
    setSelectedFile("");
  };

  const getImage = () => {
    if (selectedFile && selectedFile.length > 0) return selectedFile;
    else if (oldFile && oldFile.length > 0) return getFileLiveUrl(oldFile);
    return SELECT_USER_PHOTO;
  };

  useEffect(() => {
    if (props.profilePhoto) setOldFile(props.profilePhoto);
  }, [props.profilePhoto]);

  // const field = (fieldName) => {
  //   console.log(props.dataSource);
  //   if (props.dataSource && props.dataSource[fieldName])
  //     return props.dataSource[fieldName];
  // };

  const getReport = () => {
    setLoader(true);
    setDataList([]);
    setDataView([]);
    const form = new FormData();
    axios
      .post(
        ServiceUrl.STUDENTS.LIST_INTERNSHIP +
          "?" +
          jsonToQuery(getRandomuserParams(tableParams)) +
          "&student_uuid=" +
          context.user.uuid
      )
      .then((res) => {
        if (res["data"].status == "1") {
          setDataList(res["data"].data);
          setDataView(res["data"].data);
          setTableParams({
            ...tableParams,
            pagination: {
              ...tableParams.pagination,
              total: res["data"].count,
              // 200 is mock data, you should read it from server
              // total: data.totalCount,
            },
          });
        } else {
          Toast.show({ content: res["data"].message || "Error" });
        }
        setLoader(false);
      });
  };
  // console.log(showView.name);
  const handleView = (item) => {
    setShowView(item);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoader(true);
    axios
      .post(ServiceUrl.STUDENTS.SAVE_INTERNSHIP, $("#frm_add").serialize())
      .then((res) => {
        if (res["data"].status == "1") {
          Toast.show({ content: res["data"].message || "Saved" });

          setLoader(false);
          document.getElementById("frm_add").reset();
        } else {
          Toast.show({ content: res["data"].message || "Error" });
          setLoader(false);
        }
      });
  };

  return (
    <>
      <Header title="Internship" backAction={true} rightActions={[]} />
      {showList && (
        <div className="page-content-wrapper">
          <div className="container">
            <Card className="mb-2">
              <Card.Header style={{ position: "relative" }}>
                INTERNSHIP{" "}
                <FloatButton
                  icon={<PlusCircleOutlined style={{ verticalAlign: "3px" }} />}
                  type="default"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "absolute",
                    top: "50%",
                    right: 24,
                    transform: "translateY(-50%)",
                    width: "32px",
                    height: "32px",
                  }}
                  onClick={() => {
                    setShowList(false);

                    setShowForm(true);
                  }}
                />
              </Card.Header>
              <Card.Body className="fs-6">
                <br />
                <List>
                  {dataView.map((item) => (
                    <List.Item
                      key={item.company_name}
                      prefix={
                        <Avatar
                          style={{
                            backgroundColor: "#f56a00",
                            verticalAlign: "middle",
                            textTransform: "uppercase",
                          }}
                          size="large"
                        >
                          {item.company_name.charAt(0)}
                        </Avatar>
                      }
                      onClick={(e) => {
                        handleView(item);
                        setShowList(false);
                        setShowForm(false);
                        setShowListView(true);
                      }}
                    >
                      {item.company_name}{" "}
                      <Space size={[0, 8]} wrap>
                        {item.internship_status === "pending" ? (
                          <Tag color="red">Pending</Tag>
                        ) : (
                          <Tag color="green">Approved</Tag>
                        )}
                      </Space>
                      <br />
                      {momentDate(item.from_date, "DD-MM-YYYY")} -
                      {momentDate(item.to_date, "DD-MM-YYYY")}
                    </List.Item>
                  ))}
                </List>
              </Card.Body>
            </Card>
          </div>
        </div>
      )}
      {showForm && (
        <div className="page-content-wrapper">
          <div className="container">
            <Card className="mb-2">
              <Card.Header style={{ position: "relative" }}>
                ADD INTERNSHIP{" "}
                <FloatButton
                  icon={
                    <CloseCircleOutlined style={{ verticalAlign: "3px" }} />
                  }
                  type="default"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "absolute",
                    top: "50%",
                    right: 24,
                    transform: "translateY(-50%)",
                    width: "32px",
                    height: "32px",
                  }}
                  onClick={() => {
                    setShowForm(false);
                    setShowList(true);
                  }}
                />
              </Card.Header>
              <Card.Body>
                {/* <Button
                  type="button"
                  variant="secondary"
                  className="btn btn-block"
                  onClick={() => {
                    setShowForm(false);
                    setShowList(true);
                  }}
                >
                  Go Back
                </Button> */}
                <Form noValidate id="frm_add" onSubmit={handleSubmit}>
                  <input
                    type="hidden"
                    name="student_uuid"
                    value={context.user.uuid}
                  />
                  <input
                    type="hidden"
                    name="internship_status"
                    value="pending"
                  />
                  <input
                    type="hidden"
                    name="certificate"
                    value={selectedFile}
                  />
                  <Row>
                    <Col md={4}>
                      <Form.Label className="fs-sm">
                        From date <span className="text-danger">*</span>
                      </Form.Label>
                    </Col>
                    <Col md={4}>
                      <Form.Control
                        type="date"
                        className="fw-bold text-uppercase mt-2"
                        size="sm"
                        name="from_date"
                        required
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={4}>
                      <label className="fs-sm">
                        {" "}
                        To date <span className="text-danger">*</span>
                      </label>
                    </Col>

                    <Col md={4}>
                      <Form.Control
                        type="date"
                        className="fw-bold text-uppercase mt-2"
                        size="sm"
                        name="to_date"
                        required
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={4}>
                      <label className="fs-sm">
                        {" "}
                        Company Name <span className="text-danger">*</span>
                      </label>
                    </Col>
                    <Col md={4}>
                      <Form.Control
                        type="text"
                        name="company_name"
                        className="fw-bold mt-2"
                        size="sm"
                        required
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={4}>
                      <label className="fs-sm">
                        {" "}
                        Company Address <span className="text-danger">*</span>
                      </label>
                    </Col>
                    <Col md={4}>
                      <Form.Control
                        as="textarea"
                        name="company_address"
                        className="fw-bold mt-2"
                        size="md"
                        rows="3"
                        cols={5}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={4}>
                      <label className="fs-sm">
                        Contact Person <span className="text-danger">*</span>
                      </label>
                    </Col>
                    <Col md={4}>
                      <Form.Control
                        type="text"
                        name="contact_person"
                        className="fw-bold mt-2"
                        size="sm"
                        required
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={4}>
                      <label className="fs-sm">
                        {" "}
                        Contact Person Email{" "}
                        <span className="text-danger">*</span>
                      </label>
                    </Col>
                    <Col md={4}>
                      <Form.Control
                        type="email"
                        className="fw-bold mt-2"
                        size="sm"
                        name="email"
                        required
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={4}>
                      <label className="fs-sm">
                        {" "}
                        Contact Person Mobile{" "}
                        <span className="text-danger">*</span>
                      </label>
                    </Col>
                    <Col md={4}>
                      <Form.Control
                        type="text"
                        className="fw-bold mt-2"
                        size="sm"
                        name="mobile"
                        pattern="^((\\+91-?)|0)?[0-9]{10}$"
                        required
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={4}>
                      <label className="fs-sm">Internship Certificate</label>
                    </Col>
                    <Col md={4}>
                      <div
                        className="mt-2"
                        style={{
                          width: "180px",
                          marginLeft: "atuo",
                          marginRight: "auto",
                        }}
                      >
                        <input
                          type="hidden"
                          name="certificate"
                          value={selectedFile}
                        />
                        {selectedFile && selectedFile.length > 0 && (
                          <a
                            className="img-close-btn"
                            onClick={(e) => clearFile()}
                          >
                            x
                          </a>
                        )}
                        {selectedFile && selectedFile.length > 0 && (
                          <img
                            src={getImage()}
                            style={{
                              width: "180px",
                              cursor: "pointer",
                              height: "190px",
                            }}
                          />
                        )}
                        <ReactFileReader
                          base64={true}
                          handleFiles={fileReaderChange}
                          fileTypes={[".jpg", ".png", ".JPG", ".PNG"]}
                        >
                          <Button size="sm" type="button" className="btn-block">
                            <i className="fa-solid fa-file-image me-2"></i>
                            {selectedFile && selectedFile.length > 0
                              ? "Change Image"
                              : "Select Image"}
                          </Button>
                        </ReactFileReader>
                      </div>
                    </Col>
                  </Row>
                  <br />
                  <br />
                  <Row>
                    <Col md={4}></Col>
                    <Col md={4} className="text-end">
                      <Button
                        type="submit"
                        variant="success"
                        className="btn btn-block "
                      >
                        save
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Card.Body>
            </Card>
          </div>
        </div>
      )}
      {showListView && (
        <div className="page-content-wrapper">
          <div className="container">
            <Card className="mb-2">
              <Card.Header style={{ position: "relative" }}>
                VIEW INTERNSHIP{" "}
                <FloatButton
                  icon={
                    <CloseCircleOutlined style={{ verticalAlign: "3px" }} />
                  }
                  type="default"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "absolute",
                    top: "50%",
                    right: 24,
                    transform: "translateY(-50%)",
                    width: "32px",
                    height: "32px",
                  }}
                  onClick={() => {
                    setShowListView(false);
                    setShowList(true);
                  }}
                />
              </Card.Header>
              <Card.Body>
                <div style={{ display: "" }}>
                  <div id="view">
                    <table
                      width="100%"
                      align="center"
                      className="font-bookman"
                      cellPadding={3}
                    >
                      <thead>
                        <tr align="center">
                          <th colSpan={3} align="center" height="30">
                            <b>SCHOOL OF EXCELLENCE IN LAW</b>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td width="30%"> Name </td>
                          <td align="center" width="10%">
                            :
                          </td>
                          <td width="70%"> {showView.name}</td>
                        </tr>
                        <tr>
                          <td width="30%"> From Date</td>
                          <td align="center" width="10%">
                            :
                          </td>
                          <td>
                            {" "}
                            {momentDate(showView.from_date, "YYYY-MM-DD")}
                          </td>
                        </tr>
                        <tr>
                          <td width="30%"> To Date</td>
                          <td align="center" width="10%">
                            :
                          </td>
                          <td width="70%">
                            {" "}
                            {momentDate(showView.to_date, "YYYY-MM-DD")}
                          </td>
                        </tr>
                        <tr>
                          <td width="30%"> Company Name</td>
                          <td align="center" width="10%">
                            :
                          </td>
                          <td width="70%"> {showView.company_name}</td>
                        </tr>
                        <tr>
                          <td width="30%"> Company Address</td>
                          <td align="center" width="10%">
                            :
                          </td>
                          <td width="70%"> {showView.company_address}</td>
                        </tr>
                        <tr>
                          <td width="30%"> Contact Person</td>
                          <td align="center" width="10%">
                            :
                          </td>
                          <td width="70%"> {showView.contact_person}</td>
                        </tr>
                        <tr>
                          <td width="30%"> Contact Email</td>
                          <td align="center" width="10%">
                            :
                          </td>
                          <td width="70%"> {showView.email}</td>
                        </tr>
                        <tr>
                          <td width="30%"> Contact Mobile</td>
                          <td align="center" width="10%">
                            :
                          </td>
                          <td> {showView.mobile}</td>
                        </tr>
                        <tr>
                          <td width="30%"> Internship Status</td>
                          <td align="center" width="10%">
                            :
                          </td>
                          <td width="70%"> {showView.internship_status}</td>
                        </tr>
                        {/* <tr>
                          <td width="30%"> Internship Certificate</td>
                          <td align="center" width="10%">
                            :
                          </td>
                          <td width="70%"> {showView.certificate}</td>
                        </tr> */}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
      )}

      {/* <Modal show={showAdd} onHide={(e) => setShowAdd(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add Internship</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddInternship
            onHide={(e) => setShowAdd(false)}
            onSuccess={(e) => getReport()}
          />
        </Modal.Body>
      </Modal>
      <Modal show={showAdd1} onHide={(e) => setShowAdd1(false)}>
        <Modal.Header closeButton>
          <Modal.Title>View Internship</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ViewInternship
            dataSource={showView}
            onHide={(e) => setShowAdd1(false)}
          />
        </Modal.Body>
      </Modal> */}
    </>
  );
};
export default Internship;
